// hooks/useCollectionData.js
import { useState, useEffect } from 'react';
import { ProjectService } from '@/services/ProjectService';


export const useCollectionData = (collectionId) => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
  
    useEffect(() => {
      const fetchData = async () => {
        if (!collectionId) {
          setData(null);
          setIsLoading(false);
          return;
        }
  
        setIsLoading(true);
        try {
          const result = await ProjectService.getCollectionData(collectionId);
          setData(result.data);
          setError(null);
        } catch (err) {
          setError(err);
        } finally {
          setIsLoading(false);
        }
      };
  
      fetchData();
    }, [collectionId]);
  
    return { data, isLoading, error };
  };